<template>
  <div>
    <div class="content">

      <div class="contentL">
        <div class="tree">
          <div class="" v-for="(item, index) in dataList" :key="index">
            <div class="treeTitle" @click="titleTree(item)">
              <span class="searchIcon " :class="icon ? 'search-title' : ''" @click="searchIcon"></span>
              <img src="../../assets/images/dailyWork/iconTitle.png" alt="">
              <div> {{ item.label }}</div>
            </div>
            <div class="demo" v-if="icon">
              <div class="treeContent" v-for="(content, index) in item.children" :key="index"
                @click="treeContent(item, content)">
                <span class=" searchContent1"></span>
                <div class="treeContentText" :class="selectContent == content.id ? 'treeContentText1' : ''">
                  <div class="">
                    <img v-if="selectContent == content.id" src="../../assets/images/dailyWork/0.png" alt="">
                    <img v-else src="../../assets/images/dailyWork/1.png" alt="">
                  </div>
                  <div class="demo">{{ content.name }}</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="contentR">
        <div class="prompt">
          <img src="../../assets/images/LTicon.png" alt="">
          <div class="promptText">知识库</div>
        </div>
        <div class="searchContent">
          <div class="search">
            <div class="formList">
              <el-form :inline="true" :model="formInline" class="demo-form-inline">

                <el-form-item label="文件名称：">
                  <el-input clearable v-model="formInline.originalFileName" placeholder="请输入文件名称"
                    class="custom-input"></el-input>
                </el-form-item>
                <el-form-item>
                </el-form-item>
              </el-form>
            </div>
            <div class="newView">
              <el-button type="primary" size="small" @click="onSubmit" icon="el-icon-search"
                class="custom-button">查询</el-button>
              <el-button type="primary" size="small" @click="upDataFile" icon="el-icon-plus"
                :class="isStringInArray('btnUploadFile') ? '' : 'btnShowAuthority'"
                class="custom-button">上传文件</el-button>
              <el-button type="primary" size="small" @click="newType(0)" icon="el-icon-folder-add"
                :class="isStringInArray('btnNewType') ? '' : 'btnShowAuthority'" class="custom-button">新建类型</el-button>
              <el-button type="primary" :disabled="this.id == ''" size="small" @click="newType(1)"
                :class="isStringInArray('btnModifyType') ? '' : 'btnShowAuthority'" icon="el-icon-edit-outline"
                class="custom-button">修改类型</el-button>
              <el-button type="primary" :disabled="this.id == ''" size="small" @click="deleteType(0)"
                :class="isStringInArray('btnDeleteType') ? '' : 'btnShowAuthority'" icon="el-icon-delete"
                class="custom-button">删除类型</el-button>
            </div>
          </div>
        </div>
        <div class="table">
          <el-table v-loading="dataLoading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.3)" :cell-style="{ color: '#AED6FF', fontSize: '12px' }"
            :header-cell-style="{ color: '#e8f4ff', fontSize: '14px' }" border :data="tableData" style="width: 100%"
            class="custom-table">
            <div slot="empty">
              <div v-if="tableData.length == 0">
                <div class="empty-data-view">
                  <div class="tableText">
                    {{ dataLoading ? '' : '暂无数据' }}
                  </div>
                </div>
              </div>
            </div>
            <el-table-column align="center" label="序号" type="index" :index="getIndex" width="100">
            </el-table-column>
            <el-table-column align="center" prop="originalFileName" label="文件名" width="300">
            </el-table-column>
            <el-table-column align="center" prop="size" label="文件大小" :fluid="true" min-width="200">
            </el-table-column>
            <el-table-column align="center" prop="userName" label="创建人" width="100">
            </el-table-column>
            <el-table-column align="center" prop="createTime" label="创建时间" width="300">
            </el-table-column>
            <el-table-column align="center" prop="data" fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button :class="isStringInArray('btnDelete') ? '' : 'btnShowAuthority'"
                  @click="replyDialog(scope.row, 1)" type="text">删除</el-button>
                <span :class="isStringInArray('btnDelete') ? '' : 'btnShowAuthority'">|</span>
                <el-button :class="isStringInArray('btnDownload') ? '' : 'btnShowAuthority'"
                  @click="replyDialog(scope.row, 2)" type="text">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <div class="btn" @click="startHome">首页</div>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
            layout="prev, pager, next, sizes" :prev-text="prevButtonText" :next-text="nextButtonText"
            prev-button-class="custom-prev-button" next-button-class="custom-next-button" :total="total">
          </el-pagination>
          <div class="btn endBtn" @click="endHome">尾页</div>
          <div class="paginationEnd">
            <div>跳</div>至
            <el-input size="mini" @change="paginationEnd" class="paginationEndIpt" @input="handleEdit"
              v-model.number="paginationEndIpt"></el-input>
            <div>页</div>
            <div class="btn confirm" @click="jumpPage">确定</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 上传文件弹窗 -->
    <el-dialog @close="closeFile" title="上传文件" :visible.sync="centerDialogVisible" width="30%">
      <div class="newCenter">
        <el-form :model="ruleForm1" :rules="rules" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
          <el-form-item label="批量上传" prop="">
            <el-upload action="" ref="upload" :show-file-list="true" :auto-upload="false" :on-remove="handleRemove"
              :on-change="(file, fileList) => {
            imgUpload1(file, fileList);
          }" :limit="10" multiple :file-list="FileList">
              <el-button class="dialogBtn">上传</el-button>
              <div slot="tip" class="el-upload__tip">
                <span style="color: #aed6ff;font-size: 12px;">批量上传一次最多添加9个附件,单个附件最大不超过30M</span>
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">

        <el-button class="dialogBtn" @click="centerDialogVisible = false">取 消</el-button>
        <el-button class="dialogBtn" type="primary" :disabled="file.length == 0" @click="fileUpload">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="searchType == 0 ? '新建类型' : '修改类型'" @close="ruleHandleClose('ruleForm')"
      :visible.sync="replyDialogVisible" width="30%">
      <div class="newCenter">
        <el-form :model="ruleForm" :rules="rulesType" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="文件类型" prop="name">
            <el-input maxlength="30" show-word-limit v-model.trim="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="">
            <el-input type="textarea" :rows="4" v-model.trim="ruleForm.remark"></el-input>
          </el-form-item>
        </el-form>

      </div>
      <span slot="footer" class="dialog-footer">

        <el-button class="dialogBtn" @click="replyDialogVisible = false">取 消</el-button>
        <el-button class="dialogBtn" type="primary" @click="workTypeAdd1('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 删除分类 -->
    <el-dialog :title="deleteContText == 1 || deleteContText == 0 ? '删除' : '下载'" :visible.sync="centerDialogVisible1"
      width="20%">
      <div class="deleteCenter">
        <!-- 确定删除该分类吗? -->
        {{ deleteContText == 0 ? '确定删除该分类吗?' : deleteContText == 1 ? '确定要删除该文件吗？' : '确定下载该文件?' }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialogBtn" @click="centerDialogVisible1 = false">取 消</el-button>
        <el-button class="dialogBtn" type="primary" :loading="btnLoading" @click="deleteDialog">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { libraryWorkType, workTypeAdd, workTypeUpdate, libraryWorkTypeDelete, sysFileList, sysFileDelete, sysFileUpload, sysFileDownLoad } from '../../api/dailyWork.js'
// import demo from "./demo.vue"
export default {
  name: 'Administration',
  data() {
    return {
      btnLoading: false,
      content: '',
      FileList: [],
      formInline: {
        originalFileName: '',
        dataId: ''
      },
      tableData: [

      ],
      centerDialogVisible: false,
      replyDialogVisible: false,
      centerDialogVisible1: false,
      deleteContText: '',
      prevButtonText: '上一页',
      nextButtonText: '下一页',
      paginationEndIpt: '',
      pageSize: 10,
      currentPage: 1,
      total: 0,
      textarea: '',
      dataList: [
        {
          label: '全部',
          children: [

          ]
        },

      ],
      treeTitle: [],
      treeText: '',
      selectContent: '',
      icon: true,
      ruleForm: {
        name: '',
        remark: '',
        type: 2,
      },
      ruleForm1: {
        dictName: '',
        dictCode: '',
        dictDesc: ''
      },
      id: '',
      originalFileName: '',
      searchType: 0,
      tableId: '',
      file: [],
      fileName: [],
      dataLoading: false,
      rules: {
        dictName: [
          { required: true, message: '请输入文件类型', trigger: 'blur' },
        ],
        dictCode: [
          { required: true, message: '请选择文件', trigger: 'blur' },
        ],
      },
      rulesType: {
        name: [
          { required: true, message: '请输入文件类型', trigger: 'blur' },
        ],
      },
      authorityListBtn: []

    };
  },
  // components:{demo},

  mounted() {
    // let pageText = document.getElementsByClassName('el-pagination__jump')[0]
    // pageText.childNodes[0].nodeValue = '跳至'
    // pageText.childNodes[2].nodeValue = '页'
    this.getTreeList()
    this.authorityListBtn = sessionStorage.getItem('roleInfo')

  },
  created() {
    this.$store.commit('increment', '知识库')
    this.$store.commit('selectChild', '')
    // this.getList()
  },
  watch: {
    // 如果只需要监听对象中的一个属性值，则可以做以下优化：使用字符串的形式监听对象属性：
    "currentPage": {
      // 执行方法
      handler(newValue, oldValue) {
        this.paginationEndIpt = newValue;
      },
      immediate: true, // 第一次改变就执行
    },
  },


  methods: {
    //按钮权限
    isStringInArray(str) {
      if (this.authorityListBtn) {
        let list = this.authorityListBtn.includes(str);
        return list
      } else {
        return false
      }
    },
    closeFile() {
      this.file = []
      this.FileList = []
    },
    //序号
    getIndex(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },
    //关闭弹窗
    handleClose() {
      this.addForm = this.$options.data().addForm
    },
    ruleHandleClose(ruleForm) {
      this.ruleForm = this.$options.data().ruleForm
      this.$refs[ruleForm].resetFields();
    },
    fileUpload() {
      let file = this.file
      let formData = new FormData();
      console.log(file);
      for (let i = 0; i < file.length; i++) {
        formData.append("multipartFiles", file[i]);
      }
      // formData.append("multipartFiles", [{list:[1,2,3]}]);
      // formData.append("list", '[{list:[1,2,3]}]');
      formData.append("dataId", this.id);
      sysFileUpload(formData).then(res => {
        if (res.code == 200) {
          this.ruleForm1.dictCode = file.name
          this.centerDialogVisible = false
          this.file = []
          this.FileList = []
          this.getTreeList()
          this.$message({
            message: res.message,
            type: 'success',
            duration: 3000,
            customClass: "messageText",
          });
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            duration: 3000,
            customClass: "messageText",
          });
        }
      })
    },

    //上传
    imgUpload1(file, fileList) {
      if (file.size < 31457280) {
        if (fileList.length <= 9) {
          this.file = fileList.map(item => item.raw);
        } else {
          fileList.pop()
          this.$message({
            message: '您已选择9个附件',
            type: 'warning',
            duration: 3000,
            customClass: "messageText",
          });
        }
        console.log(this.file);
      } else {
        fileList.pop()
        this.$message({
          message: `您选择的文件:${file.name}大于30M`,
          type: 'warning',
          duration: 3000,
          customClass: "messageText",
        });

      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.file = fileList.map(item => item.raw);
      // this.file.push(file.row)

    },

    //删除确定
    deleteDialog() {
      //删除分类
      if (this.deleteContText == 0) {
        libraryWorkTypeDelete(this.id).then(res => {
          if (res.code == 200) {
            
            this.centerDialogVisible1 = false
            this.$message({
              message: res.message,
              type: 'success',
              duration: 3000,
              customClass: "messageText",
            });
            this.id = ''
            this.formInline.dataId=''
            this.getTreeList()
          } else {
            this.$message({
              message: res.message,
              type: 'error',
              duration: 3000,
              customClass: "messageText",
            });
          }
        })
      }
      //删除table
      if (this.deleteContText == 1) {
        sysFileDelete(this.tableId).then(res => {
          if (res.code == 200) {
            this.centerDialogVisible1 = false
            this.$message({
              message: res.message,
              type: 'success',
              duration: 3000,
              customClass: "messageText",
            });
            this.getList()

          } else {
            this.$message({
              message: res.message,
              type: 'error',
              duration: 3000,
              customClass: "messageText",
            });
          }
        })

      }
      //下载文件
      if (this.deleteContText == 2) {
        this.btnLoading = true
        sysFileDownLoad({ id: this.tableId }).then(res => {
          console.log("res=====>", res);
          const link = document.createElement('a');
          // const filename = res.headers['Content-Disposition'].split('filename=')[1]; // 获取文件名称
          link.href = URL.createObjectURL(new Blob([res]));
          link.download = decodeURIComponent(this.originalFileName); // 解码文件名称，避免名称中含有中文时乱码
          link.click();
          this.centerDialogVisible1 = false
          this.btnLoading = false
        })

      }

    },

    //新增类型
    workTypeAdd1(ruleForm) {
      // if (this.searchType == 1 ) {

      //   console.log("123456");
      //   let content = this.dataList[0].children[0]
      //   this.ruleForm.name = content.name
      //   this.ruleForm.remark = content.remark
      // }
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let func = this.searchType == 0 ? workTypeAdd(this.ruleForm) : workTypeUpdate({ ...this.ruleForm, id: this.id })
          func.then(res => {
            if (res.code == 200) {
              this.replyDialogVisible = false
              this.$message({
                message: res.message,
                type: 'success',
                duration: 3000,
                customClass: "messageText",
              });
              this.$refs.ruleForm.resetFields();
              this.ruleForm = this.$options.data().ruleForm
              this.getTreeList()

            } else {
              this.$message({
                message: res.message,
                type: 'error',
                duration: 3000,
                customClass: "messageText",
              });
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    //左侧tree
    getTreeList() {
      // this.dataLoading = true
      libraryWorkType().then(res => {
        // console.log(res);
        if (res.code == 200) {
          this.dataList[0].children = res.data
          if(res.data.length>0){
            console.log('=====>',res.data);
            // console.log("11111111",this.id);
            if (this.id == '') {
              this.formInline.dataId = this.dataList[0].children[0].id
              this.selectContent = this.dataList[0].children[0].id
              this.content = this.dataList[0].children[0]
              this.id = this.dataList[0].children[0].id
              console.log(this.formInline);
            } else {
              let information = this.dataList[0].children.find(item => item.id === this.id);
              console.log(information);
              this.formInline.dataId = information.id
              this.selectContent = information.id
              this.content = information
  
            }
            this.getList()
          }

        } else {
          this.$message({
            message: res.message,
            type: 'error',
            duration: 3000,
            customClass: "messageText",
          });
          this.dataLoading = false
        }
      })

    },
    // 
    searchIcon() {
      this.icon = !this.icon
    },
    //列表查询
    getList() {
      this.dataLoading = true
      let obj = {
        ...this.formInline,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      sysFileList(obj).then(res => {
        this.dataLoading = false
        // console.log(res);
        if (res.code == 200) {
          this.tableData = res.data
          if(res.total){

            this.total = res.total
          }else{
            this.total = 0
          }
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            duration: 3000,
            customClass: "messageText",
          });
        }
      })
    },
    //下载/删除
    replyDialog(el, type) {
      console.log(el.data);
      this.tableId = el.id
      this.originalFileName = el.originalFileName
      this.centerDialogVisible1 = true
      this.deleteContText = type
    },
    //查询列表
    onSubmit() {
      console.log('submit!');
      this.getList()

    },
    //上传文件
    upDataFile() {
      if( this.formInline.dataId){

        this.centerDialogVisible = true
      }else{
        this.$message({
            message: '请创建分类后在进行文件上传',
            type: 'warning',
            duration: 3000,
            customClass: "messageText",
          });
      }

    },
    //新建类型
    newType(type) {

      this.searchType = type
      this.replyDialogVisible = true
      if (type == 1) {

        let content = this.content
        this.id = content.id
        this.ruleForm.name = content.name
        this.ruleForm.remark = content.remark
        console.log("222222");
      } else {
        console.log("111111111111");
        this.ruleForm = this.$options.data().ruleForm
      }

    },

    //删除
    deleteType(type) {
      this.centerDialogVisible1 = true
      this.deleteContText = type


    },



    //分页相关function
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val
      this.paginationEnd()
      this.getList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.paginationEndIpt = val
      console.log(`当前页: ${val}`);
      console.log(this.currentPage);
      this.getList()
    },
    //首页
    startHome() {
      this.currentPage = 1
      this.getList()

    },
    //尾页
    endHome() {
      const lastPage = Math.ceil(this.total / this.pageSize);
      this.currentPage = lastPage;
      this.getList()
    },
    //输入校验
    handleEdit(e) {
      let value = e.replace(/[^\d]/g, ""); // 只能输入数字
      value = value.replace(/^0+(\d)/, "$1"); // 第一位0开头，0后面为数字，则过滤掉，取后面的数字
      this.paginationEndIpt = value
      // console.log('value===>',value);
    },
    //页数输入时
    paginationEnd() {
      const lastPage = Math.ceil(this.total / this.pageSize);
      if (this.paginationEndIpt < 1) {
        this.paginationEndIpt = 1
      } else {
        this.paginationEndIpt = this.paginationEndIpt < lastPage ? this.paginationEndIpt : lastPage
      }
    },
    //跳转
    jumpPage() {
      this.currentPage = this.paginationEndIpt
      this.getList()
      // this.paginationEndIpt=''
    },
    //点击父节点
    titleTree(item) {
      // this.treeTitle.push(item.label)
      // this.treeTitle = [...new Set(this.treeTitle)];
      console.log(this.treeTitle);
      // const index = this.treeTitle.findIndex(item => item.label === item.label);
      const index = this.treeTitle.indexOf(item.label);
      if (index !== -1) {
        // 对象已存在于数组中，删除它
        this.treeTitle.splice(index, 1);
      } else {
        // 对象不存在于数组中，添加它
        this.treeTitle.push(item.label);
      }

    },
    // 点击子节点
    treeContent(item, content) {
      this.content = content
      this.searchType = 1
      console.log(item, content);
      this.ruleForm.name = content.name
      this.ruleForm.remark = content.remark
      this.id = content.id
      this.treeText = item.id

      this.selectContent = content.id
      this.formInline.dataId = content.id
      console.log(this.ruleForm);
      this.getList()
    }


  },
};
</script>

<style src="@/utils/style/table.css" scoped></style>

<style scoped>
/* import */
.content {
  width: 100%;
  height: 100%;
  background: url(../../assets/images/rightBG.png);
  background-repeat: no-repeat;
  background-position: left left;
  background-size: cover;
  font-size: 16px;
  display: flex;

}

.contentL {
  width: 400px;
  margin: 28px 0 30px 0px;
  /* background: #071536; */

}

.contentR {
  width: 100%;
  overflow: auto;
}

.prompt {
  padding: 28px 0 0 17px;
  font-size: 16px;
  color: #ebf4ff;
  display: flex;
  align-items: center;
}

.promptText {
  margin-left: 10px;
}

/* .el-input>>>.el-input__inner {
  background-color: #061b45;
  border: 1px solid #09295b;
  color: #AED6FF;
}

.el-form-item>>>.el-form-item__label {
  font-size: 12px;
  color: #AED6FF;
}

.custom-input ::placeholder {
  color: #AED6FF;
}

.custom-button {
  background: #176ad2;
} */

.searchContent {
  margin: 11px 25px 16px 26px;
}

.search {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 14px 26px 23px 20px;

  background: #061C45;
}

.custom-pager-text {
  margin-right: 5px;
}

.custom-page-input {
  width: 60px;
  margin-right: 5px;
}

.custom-page-button {
  padding: 5px 10px;
}


.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 21px;
}

.btn {
  width: 60px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  background: rgba(255, 255, 255, 0);
  border: 1px solid #0b2653;
  border-radius: 2px;
  color: #92b5da;

}

.btn:hover {
  color: #ffffff;
}

.el-pagination>>>.btn-prev,
.el-pagination>>>.btn-next {
  background: rgba(255, 255, 255, 0);
  color: #d7d7d7;
  border-radius: 2px;
  border: 1px solid #0b2653;
  margin-right: 5px;
}

.el-pagination>>>.el-pager li {
  background: rgba(255, 255, 255, 0);
  color: #d7d7d7;
  border-radius: 2px;
  border: 1px solid #0b2653;
  margin-right: 5px;
}

.el-pagination>>>.el-pager .active {
  background: #176AD2;
  color: #d7d7d7;
  border-radius: 2px;
  border: 1px solid #0b2653;
  margin-right: 5px;
}

::v-deep .el-input__inner {
  background: rgba(255, 255, 255, 0);
  color: #d7d7d7;
  border-radius: 2px;
  border: 1px solid #0b2653;

}

.endBtn {
  margin-left: -15px;
  margin-right: 10px;
}

.paginationEnd {
  display: flex;
  justify-content: center;
  align-items: center;
}

.paginationEndIpt {
  width: 30px;
  margin: 0 7px;
  padding: 0;
  color: #92b5da;
  /* height: 16px; */
}

.paginationEndIpt>>>.el-input__inner {
  padding: 0 5px;
}

.confirm {
  margin-left: 10px;
  background: #176AD2;
  color: #d7d7d7;
}

/* 弹窗 */
::v-deep .el-dialog {
  background-color: #061d4a;
  font-size: 16px;
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid #09295b;
}

::v-deep .el-dialog__title {
  font-size: 16px;
  color: #fff;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  font-size: 16px;
  color: #000;
}

.dialogBtn {
  width: 100px;
  height: 35px;
  background: #2142A1;
  border: 0;
  color: #fff;
}

.newCenter {
  margin-bottom: 20px;
  /* display: flex; */
}

.newCenterText {
  width: 80px;
  color: #C9D4D4;
}

::v-deep .el-textarea__inner {
  background-color: #061D4A;
  color: #AED6FF;
  border: 1px solid #09295b;
  font-family: "Microsoft YaHei", Arial, sans-serif;
}

.custom-input-textarea ::placeholder {
  color: #667597;
}

.newCenterKey {
  width: 50px;
  color: #C9D4D4;
}


.tree {
  margin-top: 21px;
  /* background: #071734 ; */
  color: #aed6ff;

}

.treeContent {
  height: 40px;
  width: 300px;
  /* line-height: 59px; */
  font-size: 14px;
  margin-left: 52px;
  display: flex;
  align-items: center;

}

.treeTitle {
  height: 32px;
  line-height: 32px;
  margin-left: 22px;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.treeTitle img {
  margin-right: 10px;
}

.searchIcon {
  width: 25px;
  height: 15px;
  background: url(../../assets/images/dailyWork/BG.png);
  background-repeat: no-repeat;
  background-position: -5px -15px
}

.search-title {
  /* background-position: -5px -15px; */
  background-position: -27px -15px;
}

.searchContent1 {
  width: 8px;
  padding: 0px 0 0 0;
  margin: 0px 0 0 0px;
  height: 100%;
  /* border: 1px solid red; */
  background: url(../../assets/images/dailyWork/line.png);
  /* background-size: cover; */
  background-position: 0px 39px;

}

.treeContentText {
  margin-top: 40px;
  padding: 2px;
  width: 300px;
  display: flex;
  align-items: center;
  cursor: pointer;
  box-sizing: border-box;
  /* background: #000; */

}

.treeContentText img {
  height: 100%;

}

.treeContentText div {
  height: 20px;
}

.treeContentText :hover {
  /* background: #0E2751; */
  color: #FFC74A;
  /* background: #1b386b; */

}

.treeContentText1 {
  /* background: #1b386b; */

  color: #FFC74A;

}

.demo {
  /* width: 125px; */

}

::v-deep .el-input-group__append {
  background: #2142A1;
  color: #EFFDEE;
  border: 0;
}

.deleteCenter {
  font-size: 16px;
  color: #EBEDF1;
}

.fileList {
  color: #ead6ff;
  font-size: 12px;
  line-height: 18px;
}

::v-deep .el-upload-list__item:hover {
  background: #061D4A;
}

::v-deep .el-upload-list__item-name {

  color: #aed6ff;
}

/* 修改 hover 时小 x 的颜色 */
::v-deep .el-icon-close:before {
  color: #aed6ff;
}
</style>